import { useAuthStore } from '@/stores/auth.store';
import { authService } from '@/services/auth.service';

export function useAuth() {
    const user = useAuthStore(s => s.user);
    const accessToken = useAuthStore(s => s.accessToken);
    const setSession = useAuthStore(s => s.setSession);
    const clear = useAuthStore(s => s.clear);

    const isAuthenticated = !!accessToken;

    const login = async (email: string, password: string) => {
        const res = await authService.login({ email, password });
        const data: any = res.data;
        setSession({
            user: data.user,
            accessToken: data.accessToken,
            refreshToken: data.refreshToken,
        });
        return data;
    };

    const logout = async () => {
        await authService.logout();
        clear();
    };

    return { user, isAuthenticated, login, logout };
}
